module.exports = __webpack_public_path__ + "CRA.png?1184945bb7d9856bcd14f825bbf5e615";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CRA.png
// module id = 6
// module chunks = 0